import { FC } from 'react'

import { Stack, Typography } from '@mui/material'
import { ChartsLabelMark, ChartsLabelMarkProps } from '@mui/x-charts'

import { ChartDataItem } from './types'

export const INTERACTIVE_LEGEND_TEST_ID = 'chart-interactive-legend' as const

type InteractiveLegendProps = {
  data: ChartDataItem[]
  onItemClick: (item: ChartDataItem) => void
  markType?: ChartsLabelMarkProps['type']
}

export const InteractiveLegend: FC<InteractiveLegendProps> = ({
  data,
  onItemClick,
  markType = 'circle'
}) => {
  return (
    <Stack
      data-testid={INTERACTIVE_LEGEND_TEST_ID}
      direction="column"
      alignItems="flex-start"
      flexWrap="wrap"
    >
      {data.map((item) => {
        const { label, id, color, visible } = item

        return (
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            onClick={() => onItemClick(item)}
            key={id}
            p={1}
            gap={1}
            sx={{
              cursor: 'pointer',
              textDecoration: visible ? 'none' : 'line-through'
            }}
          >
            <ChartsLabelMark type={markType} color={color} />
            <Typography fontSize="0.775rem">{label}</Typography>
          </Stack>
        )
      })}
    </Stack>
  )
}
